// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import Modal from 'react-modal';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import cardbackground from '../cardbackground.webp';
import buttonImage from '../buttonimage.webp';
import qaimage from '../qaimage.webp';

// Set the app element for react-modal once, outside the component
Modal.setAppElement(document.getElementById('root') || document.body);

function QA({ goBack, goHome, handleSaveProgress, session }) {
    const [questions, setQuestions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalVideoUrl, setModalVideoUrl] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [currentPages, setCurrentPages] = useState({});
    const [clickedQuestions, setClickedQuestions] = useState(new Set());
    // eslint-disable-next-line no-unused-vars
    const [userId, setUserId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const questionsPerPage = 5;

    useEffect(() => {
        const fetchQuestions = async () => {
            const { data, error } = await supabase
                .schema('public')
                .from('qa_questions')
                .select('*')
                .order('created_at', { ascending: false });
            if (error) {
                console.error('Fetch error details:', error);
            } else {
                console.log('Fetched questions:', data);
                setQuestions(data);
                const initialPages = {};
                ['Pending', 'Relationship', 'Communication', 'Change', 'Other', 'Activation', 'Love'].forEach(category => {
                    initialPages[category] = 1;
                });
                setCurrentPages(initialPages);
            }
        };
        fetchQuestions();
        if (session?.user?.id) {
            setUserId(session.user.id);
            console.log('User ID set to:', session.user.id);
        } else {
            console.log('Session or user ID not available');
        }
    }, [session]);

    const filteredQuestions = questions.filter(q =>
        q.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const groupedQuestions = filteredQuestions.reduce((acc, q) => {
        const category = q.category || 'Pending';
        if (!acc[category]) acc[category] = [];
        acc[category].push(q);
        return acc;
    }, {});

    const handlePageChange = (category, page) => {
        setCurrentPages(prev => ({ ...prev, [category]: page }));
    };

    const openModal = (videoLink, question) => {
        let videoUrl = '';
        setErrorMessage('');

        console.log('Parsing video link:', videoLink);

        // Handle iframe wrapper if present
        let src = videoLink;
        const iframeMatch = videoLink.match(/src="([^"]+)"/);
        if (iframeMatch) {
            src = iframeMatch[1];
        }

        if (src.includes('embed/')) {
            const videoIdMatch = src.match(/embed\/([a-zA-Z0-9_-]+)/);
            if (videoIdMatch) {
                videoUrl = src;
                console.log('Final embed URL for iframe:', videoUrl);
            }
        } else {
            const videoIdMatch = src.match(/(?:watch\?v=|youtu.be\/)([a-zA-Z0-9_-]+)/);
            if (videoIdMatch) {
                videoUrl = `https://www.youtube.com/embed/${videoIdMatch[1]}`;
            }
        }

        if (videoUrl) {
            console.log('Opening modal with video URL:', videoUrl);
            setModalVideoUrl(videoUrl);
            setSelectedQuestion(question);
            setModalIsOpen(true);
        } else {
            console.error('Invalid video link:', videoLink);
            setErrorMessage('Invalid video link format.');
            setModalIsOpen(true);
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setModalVideoUrl('');
        setSelectedQuestion(null);
        setErrorMessage('');
    };

    const handleQuestionClick = (question) => {
        setClickedQuestions(prev => {
            const newSet = new Set(prev);
            newSet.has(question.qa_id) ? newSet.delete(question.qa_id) : newSet.add(question.qa_id);
            return newSet;
        });
    };

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
                paddingBottom: '100px', // Increased to ensure sticky footer does not cover content
            }}
        >
            {/* Payment Card */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    backgroundColor: 'white',
                    marginBottom: '24px',
                    overflow: 'hidden',
                }}
            >
                <img
                    src={qaimage}
                    alt="Q & A"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <h2
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Q & A
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Add your question to the list for $2. Answers will be posted as they are available. Questions are added to the list anonymously. You will have to check back for your answer which will be public on this page when it is added.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        I will work on these answers and add them as soon as possible, which may take more than a week.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        You can ask about personal situations, but please do not include personal identification or contact information. Do not ask about Emergency situations. This is not the place for Medical advice or Care. This is a self reflection companion app and questions will be answered at the discretion of the App Creator. No Refunds for inappropriate questions that will not be answered. Personal situation question may be answered, but information will be added to ensure that answers could apply to anyone the question and answer resonate to. All answers offered are from the perspective of the App creator and given for the purpose of self reflection.  By participating in this page you agree to taking full responsibility for how you use the information shared. 
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        If I consult cards for an answer that will be noted. Some Answers will be in paragraph format with text response, while others will include an embedded unlisted YouTube link.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        I do not know everything. If I do not know an answer I may try to find an answer, I may consult my oracle, and I may have to let you know that I do not know; with a suggestion for how to find what you need.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        No Refunds in cases where the answer is unacceptable or unhelpful, and no promise of answer in cases where the question is unacceptable or inappropriate. I look forward to adding to this database here over time and I appreciate your participation greatly! You addition to the database is appreciated but not guaranteed.  The fee ensures that I will review the question and decide whether or not to include it. Payment rendered is for the service of having your question considered only, with no guarantee of answer or helpful answer given.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Thank you in advance for your thoughtful, inspiring, and helpful questions.
                    </p>
                    {/* Replace the PayPal sandbox form with the new live PayPal button */}
                    <form
                        action="https://www.paypal.com/ncp/payment/WRFSD6D4GSS5C"
                        method="post"
                        target="_blank"
                        style={{ display: 'inline-grid', justifyItems: 'center', alignContent: 'start', gap: '0.5rem' }}
                    >
                        <input className="pp-WRFSD6D4GSS5C" type="submit" value="Pay $2" />
                        <img src="https://www.paypalobjects.com/images/Debit_Credit_APM.svg" alt="cards" />
                        <section style={{ fontSize: '0.75rem' }}>
                            Powered by{' '}
                            <img
                                src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg"
                                alt="paypal"
                                style={{ height: '0.875rem', verticalAlign: 'middle' }}
                            />
                        </section>
                    </form>
                    <style>{`.pp-WRFSD6D4GSS5C{text-align:center;border:none;border-radius:1.5rem;min-width:11.625rem;padding:0 2rem;height:3.125rem;font-weight:bold;background-color:#bdf7ff;color:#000000;font-family:'Helvetica Neue',Arial,sans-serif;font-size:1.125rem;line-height:1.5rem;cursor:pointer;}`}</style>
                </div>
            </div>

            {/* Pending Section */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    margin: '0 auto 24px auto',
                }}
            >
                <div
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderRadius: '10px',
                        border: '2px solid #4B5563',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                        padding: '10px 20px',
                        marginBottom: '16px',
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search questions..."
                        style={{
                            width: '100%',
                            maxWidth: '300px',
                            padding: '10px',
                            border: '2px solid transparent',
                            borderRadius: '10px',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '14px',
                            marginBottom: '16px',
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <strong style={{ fontSize: '18px', color: '#4B5563' }}>Pending</strong>
                    {(() => {
                        const totalPages = Math.ceil((groupedQuestions['Pending']?.filter(q => !q.completed_at) || []).length / questionsPerPage);
                        const currentPage = currentPages['Pending'] || 1;
                        const startIndex = (currentPage - 1) * questionsPerPage;
                        const paginatedQuestions = (groupedQuestions['Pending']?.filter(q => !q.completed_at) || []).slice(startIndex, startIndex + questionsPerPage);

                        return (
                            <>
                                {paginatedQuestions.length > 0 ? (
                                    paginatedQuestions.map(q => (
                                        <div key={q.qa_id} style={{ marginTop: '1px' }}>
                                            <div
                                                style={{ cursor: 'pointer', color: '#0066cc' }}
                                                onClick={() => {
                                                    if (q.completed_at && q.answer_type === 'video' && q.answer_link) {
                                                        openModal(q.answer_link, q);
                                                    } else {
                                                        handleQuestionClick(q);
                                                    }
                                                }}
                                            >
                                                {q.question}
                                            </div>
                                            {clickedQuestions.has(q.qa_id) && !q.completed_at && (
                                                <p style={{ margin: '5px 0 0 0' }}>Check Back Later</p>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ marginTop: '10px' }}>No pending questions yet.</p>
                                )}
                                {totalPages > 1 && (
                                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                        <button
                                            onClick={() => handlePageChange('Pending', currentPage - 1)}
                                            disabled={currentPage === 1}
                                            style={{
                                                padding: '5px 10px',
                                                border: '1px solid #4B5563',
                                                borderRadius: '5px',
                                                background: 'white',
                                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            Prev
                                        </button>
                                        <span>Page {currentPage} of {totalPages}</span>
                                        <button
                                            onClick={() => handlePageChange('Pending', currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            style={{
                                                padding: '5px 10px',
                                                border: '1px solid #4B5563',
                                                borderRadius: '5px',
                                                background: 'white',
                                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </>
                        );
                    })()}
                </div>
            </div>

            {/* Category Sections */}
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '1200px' }}>
                <div style={{ width: '48%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {['Relationship', 'Communication', 'Change'].map(category => (
                        <div
                            key={category}
                            style={{
                                backgroundImage: `url(${cardBackgroundImage})`,
                                backgroundSize: 'cover',
                                borderRadius: '10px',
                                border: '2px solid #4B5563',
                                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                                padding: '20px',
                            }}
                        >
                            <strong style={{ fontSize: '18px', color: '#4B5563' }}>{category}</strong>
                            {(() => {
                                const totalPages = Math.ceil((groupedQuestions[category] || []).length / questionsPerPage);
                                const currentPage = currentPages[category] || 1;
                                const startIndex = (currentPage - 1) * questionsPerPage;
                                const paginatedQuestions = (groupedQuestions[category] || []).slice(startIndex, startIndex + questionsPerPage);

                                return (
                                    <>
                                        {paginatedQuestions.length > 0 ? (
                                            paginatedQuestions.map(q => (
                                                <div key={q.qa_id} style={{ marginTop: '10px' }}>
                                                    <div
                                                        style={{ cursor: q.completed_at && q.answer_type === 'video' ? 'pointer' : 'pointer', color: '#0066cc' }}
                                                        onClick={() => {
                                                            if (q.completed_at && q.answer_type === 'video' && q.answer_link) {
                                                                openModal(q.answer_link, q);
                                                            } else {
                                                                handleQuestionClick(q);
                                                            }
                                                        }}
                                                    >
                                                        {q.question}
                                                    </div>
                                                    {clickedQuestions.has(q.qa_id) && !q.completed_at && (
                                                        <p style={{ margin: '5px 0 0 0' }}>Check Back Later</p>
                                                    )}
                                                    {q.completed_at && q.answer_type === 'text' && (
                                                        <p style={{ margin: '5px 0 0 0' }}>{q.answer_text}</p>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <p style={{ marginTop: '10px' }}>No questions yet.</p>
                                        )}
                                        {totalPages > 1 && (
                                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                <button
                                                    onClick={() => handlePageChange(category, currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    style={{
                                                        padding: '5px 10px',
                                                        border: '1px solid #4B5563',
                                                        borderRadius: '5px',
                                                        background: 'white',
                                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    }}
                                                >
                                                    Prev
                                                </button>
                                                <span>Page {currentPage} of {totalPages}</span>
                                                <button
                                                    onClick={() => handlePageChange(category, currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                    style={{
                                                        padding: '5px 10px',
                                                        border: '1px solid #4B5563',
                                                        borderRadius: '5px',
                                                        background: 'white',
                                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                    }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                    ))}
                </div>
                <div style={{ width: '48%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {['Other', 'Activation', 'Love'].map(category => (
                        <div
                            key={category}
                            style={{
                                backgroundImage: `url(${cardBackgroundImage})`,
                                backgroundSize: 'cover',
                                borderRadius: '10px',
                                border: '2px solid #4B5563',
                                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                                padding: '20px',
                            }}
                        >
                            <strong style={{ fontSize: '18px', color: '#4B5563' }}>{category}</strong>
                            {(() => {
                                const totalPages = Math.ceil((groupedQuestions[category] || []).length / questionsPerPage);
                                const currentPage = currentPages[category] || 1;
                                const startIndex = (currentPage - 1) * questionsPerPage;
                                const paginatedQuestions = (groupedQuestions[category] || []).slice(startIndex, startIndex + questionsPerPage);

                                return (
                                    <>
                                        {paginatedQuestions.length > 0 ? (
                                            paginatedQuestions.map(q => (
                                                <div key={q.qa_id} style={{ marginTop: '10px' }}>
                                                    <div
                                                        style={{ cursor: q.completed_at && q.answer_type === 'video' ? 'pointer' : 'pointer', color: '#0066cc' }}
                                                        onClick={() => {
                                                            if (q.completed_at && q.answer_type === 'video' && q.answer_link) {
                                                                openModal(q.answer_link, q);
                                                            } else {
                                                                handleQuestionClick(q);
                                                            }
                                                        }}
                                                    >
                                                        {q.question}
                                                    </div>
                                                    {clickedQuestions.has(q.qa_id) && !q.completed_at && (
                                                        <p style={{ margin: '5px 0 0 0' }}>Check Back Later</p>
                                                    )}
                                                    {q.completed_at && q.answer_type === 'text' && (
                                                        <p style={{ margin: '5px 0 0 0' }}>{q.answer_text}</p>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <p style={{ marginTop: '10px' }}>No questions yet.</p>
                                        )}
                                        {totalPages > 1 && (
                                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                <button
                                                    onClick={() => handlePageChange(category, currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    style={{
                                                        padding: '5px 10px',
                                                        border: '1px solid #4B5563',
                                                        borderRadius: '5px',
                                                        background: 'white',
                                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    }}
                                                >
                                                    Prev
                                                </button>
                                                <span>Page {currentPage} of {totalPages}</span>
                                                <button
                                                    onClick={() => handlePageChange(category, currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                    style={{
                                                        padding: '5px 10px',
                                                        border: '1px solid #4B5563',
                                                        borderRadius: '5px',
                                                        background: 'white',
                                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                    }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal for Video Answers */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Video Answer Modal"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: '600px',
                        padding: '20px',
                        borderRadius: '10px',
                        zIndex: 1000,
                    },
                    overlay: {
                        zIndex: 999,
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    },
                }}
                portalClassName="ReactModalPortal"
            >
                <h2 style={{ fontFamily: 'Times New Roman, Times, serif', marginBottom: '20px' }}>Video Answer</h2>
                {errorMessage ? (
                    <p>{errorMessage}</p>
                ) : selectedQuestion && selectedQuestion.answer_type === 'video' && modalVideoUrl ? (
                    <div>
                        <iframe
                            src={modalVideoUrl}
                            width="100%"
                            height="315"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            title="YouTube video player"
                            onLoad={() => console.log('Iframe loaded with URL:', modalVideoUrl)}
                        />
                    </div>
                ) : (
                    <p>
                        Unable to load video. Details: 
                        {JSON.stringify({ selectedQuestion, modalVideoUrl, answerType: selectedQuestion?.answer_type })}
                    </p>
                )}
                <button
                    onClick={closeModal}
                    style={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        border: '2px solid black',
                        borderRadius: '10px',
                        background: '#FFD140',
                        fontFamily: 'Times New Roman, Times, serif',
                        cursor: 'pointer',
                    }}
                >
                    Close
                </button>
            </Modal>

            {/* Sticky Footer with duplicated buttons */}
            <footer
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px 10px 0 0',
                    boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
                    padding: '6px',
                    textAlign: 'center',
                    zIndex: 1000,
                    minHeight: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
            </footer>
        </div>
    );
}

export default QA;